import React from "react";
import { Mail, FileBarChart2 } from "lucide-react";
import { Button } from "../common/Button";
import translations from "../common/Translations";
import HoverTooltip from "../common/HoverTooltip";

const WorklogReportsHeader = ({
  title,
  subtitle,
  activeTab = "schedule",
  onScheduleClick,
  onExportClick,
  hasPDFAccess = true,
  showTabSwitcher = true,
  showScheduleTab = true,
  stackActionsUntilDesktop = false,
  extraActions = null,
  theme,
  langMode,
  isRtl = false,
}) => {
  const scheduleLabel = translations[langMode]?.Scheduleemail?.trim() || "Schedule email report";
  const scheduleShortLabel = translations[langMode]?.scheduleemail?.trim() || "Schedule email";
  const pdfLabel = translations[langMode]?.pdf?.trim() || "Export PDF";
  const responsiveRowClasses = stackActionsUntilDesktop
    ? "lg:flex-row lg:items-start lg:justify-between"
    : "sm:flex-row sm:items-start sm:justify-between";
  const responsiveActionClasses = stackActionsUntilDesktop
    ? "lg:flex-row lg:items-center lg:w-auto"
    : "sm:flex-row sm:items-center sm:w-auto";
  const responsiveExtraActionClasses = stackActionsUntilDesktop
    ? "lg:w-auto"
    : "sm:w-auto";

  return (
    <div className={`flex flex-col ${responsiveRowClasses} gap-3 ${isRtl ? (stackActionsUntilDesktop ? "lg:flex-row-reverse" : "sm:flex-row-reverse") : ""}`}>
      <div className="min-w-0 flex-1">
        <h1 className="text-base font-bold text-slate-800 leading-tight sm:text-lg">
          {title}
        </h1>
        <p className="text-xs text-slate-500 mt-0.5">
          {subtitle}
        </p>
      </div>

      <div className={`flex flex-col ${responsiveActionClasses} items-stretch gap-2 w-full shrink-0 ${isRtl ? (stackActionsUntilDesktop ? "lg:flex-row-reverse" : "sm:flex-row-reverse") : ""}`}>
        {showTabSwitcher && (
          <div
            className={`grid ${hasPDFAccess && showScheduleTab ? "grid-cols-2" : "grid-cols-1"} sm:flex sm:flex-nowrap items-center gap-1 rounded-[10px] p-1 w-full sm:w-auto ${
              theme === "dark"
                ? "bg-gray-800"
                : theme === "high-contrast"
                  ? "high-contrast border-2"
                  : "bg-gray-100/80"
            }`}
            role="group"
          >
          {showScheduleTab && (
            <HoverTooltip
              text={scheduleLabel}
              className="col-span-1 sm:col-auto relative flex min-w-0 w-full sm:w-auto"
            >
              <Button
                onClick={onScheduleClick}
                isActive={activeTab === "schedule"}
                aria-label={scheduleLabel}
                className="w-full sm:w-auto h-10 min-h-[40px] gap-1.5 rounded-[8px] px-2.5 sm:px-4 py-2 text-xs sm:text-sm justify-center min-w-0"
              >
                <Mail size={15} className="shrink-0" />
                <span className="truncate sm:hidden">{scheduleShortLabel}</span>
                <span className="truncate hidden sm:inline">{scheduleLabel}</span>
              </Button>
            </HoverTooltip>
          )}

          {hasPDFAccess && (
            <HoverTooltip
              text={translations[langMode]?.exportpdfbasedonfilters ?? "Export the PDF file based on filters"}
              className="col-span-1 sm:col-auto relative flex min-w-0 w-full sm:w-auto"
            >
              <Button
                onClick={onExportClick}
                isActive={activeTab === "export"}
                aria-label={pdfLabel}
                className="w-full sm:w-auto h-10 min-h-[40px] gap-1.5 rounded-[8px] px-2.5 sm:px-4 py-2 text-xs sm:text-sm justify-center min-w-0"
              >
                <FileBarChart2 size={15} className="shrink-0" />
                <span className="truncate">{pdfLabel}</span>
              </Button>
            </HoverTooltip>
          )}
          </div>
        )}
        {extraActions && (
          <div className={`w-full ${responsiveExtraActionClasses} flex items-center`}>
            {extraActions}
          </div>
        )}
      </div>
    </div>
  );
};

export default WorklogReportsHeader;
